'use strict';

module.exports = function (value) {
	if (value == null) throw new TypeError("Cannot use null or undefined");
	return value;
};



/*****************
 ** WEBPACK FOOTER
 ** /Users/bvaughn/Documents/git/react-devtools/~/es5-ext/object/valid-value.js
 ** module id = 19
 ** module chunks = 0
 **/